module.exports = __webpack_public_path__ + "media/pŏm mâi kâo jai loie jing jing.ed89535f.mp3";